import * as H from "history";
import { Routes } from "../../route/RoutesConfig";
import { BasePayment } from "./BasePayment";

const sanitizeReturnTo = (path?: string | null): string | undefined => {
  if (!path) return undefined;
  const trimmed = path.trim();
  if (!trimmed.startsWith("/") || trimmed.startsWith("//") || trimmed.includes("://")) {
    return undefined;
  }
  return trimmed.length > 512 ? trimmed.substring(0, 512) : trimmed;
};

/** Leading /{id} from the current customer account or employee terminal URL. */
const routeIdPrefix = (): string => {
  const match = window.location.pathname.match(/^\/(\d+)(?:\/|$)/);
  return match ? `/${match[1]}` : "";
};

export const paymentStatusPath = (
  paymentId: string,
  returnTo?: string | null
): string => {
  const params = new URLSearchParams();
  params.set("paymentId", paymentId);
  const safeReturn = sanitizeReturnTo(returnTo);
  if (safeReturn) {
    params.set("returnTo", safeReturn);
  }
  return `${routeIdPrefix()}${Routes.paymentReturn}?${params.toString()}`;
};

export const currentReturnTo = (): string =>
  sanitizeReturnTo(`${window.location.pathname}${window.location.search}`) ||
  Routes.home;

/** In-app navigation to the payment status / return page. */
export const goToPaymentStatus = (
  history: H.History,
  paymentId: string,
  returnTo?: string | null
): void => {
  history.push(paymentStatusPath(paymentId, returnTo ?? currentReturnTo()));
};

/** Full navigation (e.g. after HPP start or 409 lock). */
export const assignPaymentStatus = (
  paymentId: string,
  returnTo?: string | null
): void => {
  window.location.assign(
    paymentStatusPath(paymentId, returnTo ?? currentReturnTo())
  );
};

export class PaymentUtils {
  static setIsSuccess = (payment: BasePayment) => {
    if (payment) {
      const responseCode: number = payment.responseCode || 0;
      payment.isSuccess = responseCode.toString() === "1";
    }
  };
}
